import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumpkgContentReducer(state = initialState.verumpkgContent, action: any) {
  switch (action.type) {

    case types.SAVE_VERUMPKGCONTENT_SUCCESS:
      return action.verumpkgContent;

    default:
      return state;
  }
}
